import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGatewayModel } from 'src/app/models/api-gateway-model';
import { ApiGatewayService } from 'src/app/shared/services/api-gateway.service';
import { EmployeeProfileModel } from './employee-profile.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeProfileService {
  employeeProfileData: EmployeeProfileModel | undefined
  employeeProfileData$ = new BehaviorSubject<EmployeeProfileModel>(new EmployeeProfileModel());
  employeeIdList$ = new BehaviorSubject<any>([]);
  selectedTabIndex: number = 0;

  constructor(private apiService: ApiGatewayService) { }

  public getEmployeeProfile(employeeId: string, companyId: string): Observable<EmployeeProfileModel[]> {
    let gatewayModel: ApiGatewayModel = {
        actionDescription: "AdminGetEmployee",
        body: {},
    };
    let queryString = "?employeeId=" + employeeId + "&companyId=" + companyId;

    return this.apiService.SendRequest(queryString, gatewayModel);
  }

  public getEmployeeProfileData(): Observable<EmployeeProfileModel> {
    return this.employeeProfileData$.asObservable();
  }

  public setEmployeeProfileData(model: EmployeeProfileModel) {
      this.employeeProfileData = model
      this.employeeProfileData$.next(model);
  }

  public updateEmployeeProfile(employee: EmployeeProfileModel) {
    let gatewayModel: ApiGatewayModel = {
        actionDescription: "AdminUpdateEmployee",
        body: employee,
    };

    let queryString = "";
    return this.apiService.SendRequest(queryString, gatewayModel);
}
}
